import { attr, BaseModel, belongsTo } from "../../lib/itn-ui-kit/data";

export default class EmailModel extends BaseModel {
  @attr("string") objectId;
  @belongsTo("user") actor;
  @attr("string") actionId;
  @attr("string") sentAt;
  @attr("array") recipients;
  @attr("number") numberOfRecipients;
  @attr("string") emailLog;
  @attr("string") renderedSubject;
  @attr("string") fromEmail;
  @attr("number") status;
  @attr("number") template;
}
